import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { CurrencyBO } from '@skylab-shared/business';
import { EventBusBase } from '@skylab-shared/core';
import { CurrencyModel } from '@skylab-shared/dataModel';

import { CurrencyRepository, CurrencyRepositoryBase } from '@skylab-angular-shared/business';
import { CommandBus, EventBus, L10n, L10nBase, RootContext, RootContextBase, Weaver, WeaverBase } from '@skylab-angular-shared/core';
import { BooleanValueAccessorDirective, ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, FocusByDirective, FormContainerComponent, NumericValueAccessorDirective, TextValueAccessorDirective, ToastService, ValidateDirective, ValidationSourceDirective } from '@skylab-angular-shared/ui';

import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DictionaryDialogComponentBase, DictionaryDialogViewModelBase } from '../dictionary-dialog-base';

export interface CurrencyDialogResult {
    id: number;
    version: string;
}

interface CurrencyConfigurationViewModel extends DictionaryDialogViewModelBase<CurrencyBO> {}

@Component({
    selector: 'skl-currency-dialog',
    templateUrl: './currency-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, ValidationSourceDirective, BooleanValueAccessorDirective, FormsModule, ValidateDirective, TextValueAccessorDirective, FocusByDirective, NumericValueAccessorDirective, ButtonComponent, TranslatePipe]
})
export class CurrencyDialogComponent extends DictionaryDialogComponentBase
<
CurrencyModel,
CurrencyBO,
CurrencyRepositoryBase,
CurrencyConfigurationViewModel
> {
    public constructor(
        @Inject(CurrencyRepository) CurrencyRepository: CurrencyRepositoryBase,
        @Inject(RootContext) rootContext: RootContextBase,
        @Inject(Weaver) weaver: WeaverBase,
        @Inject(L10n) l10n: L10nBase,
        @Inject(EventBus) eventBus: EventBusBase,

        toastService: ToastService,
        commandBus: CommandBus,
        dialogService: DialogInsService
    ) {
        super(CurrencyRepository, toastService, l10n, weaver, rootContext, commandBus, eventBus, dialogService);
    }
}
